// extracted by mini-css-extract-plugin
var _1 = "pfx-CommunityTracks-module__title--lVi0d";
export { _1 as "title" }
